import { Language, TemplateSubType, TemplateType } from '../../../types/dto-app';

export const leaseOperationCreatedTemplates = [
  {
    id: '-215001',
    language: Language.EN,
    subject: 'A new exceptional charge or service has been added to your lease',
    type: TemplateType.SMS,
    subType: TemplateSubType.LEASE_OPERATION_CREATED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
          <p>Dear tenant,</p>
          <p>A new exceptional charge or service has been added to your lease.</p>
          <p>More details here : {{pdfLink}}.</p>
          <p>Kind regards.</p>
          `,
  },
  {
    id: '-215002',
    language: Language.FR,
    subject: 'Une nouvelle charge exceptionnelle ou un service a été ajouté à votre bail',
    type: TemplateType.SMS,
    subType: TemplateSubType.LEASE_OPERATION_CREATED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
          <p>Cher/Chère tenant,</p>
          <p>Une nouvelle charge exceptionnelle ou un service a été ajouté à votre bail.</p>
          <p>Plus de détails ici : {{pdfLink}}.</p>
          <p>Bien à vous.</p>`,
  },
  {
    id: '-215003',
    language: Language.NL,
    subject: 'Een nieuwe uitzonderlijke last of dienst werd aan je huurcontract toegevoegd',
    type: TemplateType.SMS,
    subType: TemplateSubType.LEASE_OPERATION_CREATED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
          <p>Beste huurder,</p>
          <p>Een nieuwe uitzonderlijke last of dienst werd aan je huurcontract toegevoegd.</p>
          <p>Alle details hier: {{pdfLink}}.</p>
          <p>Groeten.</p>
          `,
  },
  {
    id: '-215004',
    language: Language.DE,
    subject: 'Eine neue außergewöhnliche Belastung oder Leistung wurde zu Ihrem Mietvertrag hinzugefügt',
    type: TemplateType.SMS,
    subType: TemplateSubType.LEASE_OPERATION_CREATED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
          <p>Sehr geehrte/r Mieter/in,</p>
          <p>Eine neue außergewöhnliche Belastung oder Leistung wurde zu Ihrem Mietvertrag hinzugefügt.</p>
          <p>Weitere Details hier: {{pdfLink}}.</p>
          <p>Mit freundlichen Grüßen.</p>
          `,
  },
];
